import Vue        from 'vue'
export const geolocation = () => {
    return new Promise((resolve,reject)=>{
        if (!navigator.geolocation) {
            alert("你的浏览器不支持 HTML 5 Geolocation");			//判断浏览器是否支持地理定位
        } else {
            let options={
                enableHighAccuracy:true,
                timeout:10000,
                maximumAge:60000
            };		//定义一个 JSON 对象
            navigator.geolocation.getCurrentPosition(success, error , options);		//定位，第2和第3参数任选
            function success(position) {
                //定位成功时回调方法
                //坐标属性 coords 包含经度、纬度等信息
                let lat = position.coords.latitude;
                let lon = position.coords.longitude;
                Vue.http.jsonp("https://apis.map.qq.com/ws/geocoder/v1",{
                    params:{
                        key:'UW3BZ-J2JRA-XXIKC-CGQBX-ZC4Y6-NJFB5',
                        location: lat + ',' + lon,
                        output: "jsonp"
                    }
                }).then(res=>{
                    const { address,address_component,location } = res.body.result;
                    let data = {
                        addr:address,
                        city:address_component.city,
                        province: address_component.province,
                        lat:location.lat,
                        lng:location.lng,
                    }
                    resolve({status:'complete',result:data})
                })
            }
            function error(err) {
                //定位失败时的回调方法
                var errorTypes = {
                    1: "用户拒绝定位服务",			//PERMISSION_DENIED
                    2: "获取不到定位位置",			//POSITION_UNAVAILABLE
                    3: "获取定位信息超时",			//TIMEOUT
                    4: "未知错误"					//UNKNOW_ERROR
                };
                reject({msg:errorTypes[err.code],code:err.code})
                // alert(errorTypes[err.code]);	//使用数据方式访问 JSON 对象的数据
            }
        }
    })
}
